import _get from 'lodash/get';

export const scheduleIdSelector = (state, reportId) => {
	return _get(state,`schedules[${reportId}].schedule.uuid`);
};
